// Home page specific functionality
export default class Home {
  constructor() {
    this.intervalId = null;
    this.isAnimating = false;
    this.isPaused = false;
    this.bindEvents();
  }

  bindEvents() {
    if ($("#homepage-banner-slider-section").length > 0) {
      this.setupBannerSlider();
    }
  }

  setupBannerSlider() {
    $(".homepage-banner-slick-slider").slick({
      fade: true,
      arrows: true,
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      nextArrow: `<div class="slick-arrow slick-next"><img src="${HM_Variables.assets_url}img/common/banner-slide-next-ico.svg" alt="Next Button"></div>`,
      prevArrow: `<div class="slick-arrow slick-prev"><img src="${HM_Variables.assets_url}img/common/banner-slide-next-ico.svg" alt="Prev Button"></div>`,
    });
  }
}
